import React from 'react';
import { ArrowLeftIcon, CameraIcon, MicIcon, MoreVerticalIcon, PaperclipIcon, PhoneIcon, SmileIcon, StarIcon, VideoIcon } from 'lucide-react';
import { testimonios } from '../data/content';
import { Reveal } from './Reveal';
import { CHAT_BACKGROUND } from '../data/testimonialPhotos';

// Imita la pantalla de chat de WhatsApp (modo claro): tipografía del sistema y colores de la app.
const WA_FONT = 'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';
function initials(name: string) {
  return name.split(' ').map(part => part[0]).slice(0, 2).join('');
}
function BubbleTail() {
  return <svg className="absolute -left-2 top-0" width="8" height="13" viewBox="0 0 8 13" aria-hidden="true" data-id="element-218" data-mp="2x1uq2gthex2x">
      <path d="M1.533 3.568 8 12.193V1H2.812C1.042 1 .474 2.156 1.533 3.568z" fill="rgba(11,20,26,0.13)" data-id="element-219" data-mp="2s3097kf2rilg" />
      <path d="M1.533 2.568 8 11.193V0H2.812C1.042 0 .474 1.156 1.533 2.568z" fill="#fff" data-id="element-220" data-mp="v8ws66kuleb4" />
    </svg>;
}
export function Testimonials() {
  return <section className="bg-mint-50" aria-labelledby="testimonios-title" style={{
    paddingTop: "50px",
    paddingBottom: "50px"
  }} data-id="element-221" data-mp="h5y92fsm7f45">
      <div className="mx-auto max-w-6xl px-6" data-id="element-222" data-mp="m62o01dvk1s9">
        <Reveal className="max-w-3xl" data-id="element-223" data-mp="m2on6xkv00mx">
          <h2 id="testimonios-title" className="font-display text-3xl leading-tight text-ink sm:text-4xl lg:text-[2.75rem]" data-id="element-224" data-mp="78k4pejyugs7">
            Lo que nos contaron quienes ya lo probaron
          </h2>
        </Reveal>

        <ul className="mt-12 grid items-start gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-225" data-mp="zxha4h32wj3j">
          {testimonios.map((item, index) => <li key={item.name} data-id="element-226" data-mp="14uzmkhgb1gga" data-mpi={index}>
              <Reveal delay={index * 0.04} className="overflow-hidden rounded-[22px] bg-white shadow-lift ring-1 ring-black/5" data-id="element-227" data-mp="q6mmp9e3jdgi">
                <div style={{
              fontFamily: WA_FONT
            }} data-id="element-228" data-mp="v4xwjk4e5nyq">
                  <div className="flex items-center gap-2 bg-[#008069] px-2.5 py-2.5 text-white" data-id="element-229" data-mp="1ivk131f6sq3z">
                    <ArrowLeftIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-230" data-mp="1nlqsta4zwqqg" />
                    <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#dfe5e7] text-[13px] font-semibold text-[#54656f]" aria-hidden="true" data-id="element-231" data-mp="1xi0mj81kxrxl">
                      {initials(item.name)}
                    </div>
                    <p className="min-w-0 flex-1 truncate text-[16px] font-medium" data-id="element-232" data-mp="1og9g20z7th2o">{item.name}</p>
                    <div className="flex shrink-0 items-center gap-4 pr-1" aria-hidden="true" data-id="element-233" data-mp="1jh6g2uy3e11k">
                      <VideoIcon className="h-5 w-5" data-id="element-234" data-mp="1ek6h13zntyjy" />
                      <PhoneIcon className="h-[18px] w-[18px]" data-id="element-235" data-mp="19seqgtgi7stt" />
                      <MoreVerticalIcon className="h-5 w-5" data-id="element-236" data-mp="19qvbr7ahxpu5" />
                    </div>
                  </div>

                  <div className="bg-[#efeae2] px-3 pb-3 pt-4" style={{
                backgroundImage: `url("${CHAT_BACKGROUND}")`,
                backgroundSize: '350px auto',
                backgroundRepeat: 'repeat'
              }} data-id="element-237" data-mp="14tlej5gv89vr">
                    <div className="flex flex-col items-start gap-[3px]" data-id="element-238" data-mp="qtaizp4m2749">
                      {item.messages.map((message, messageIndex) => <div key={messageIndex} className={`relative ml-2 mr-8 rounded-lg bg-white shadow-[0_1px_0.5px_rgba(11,20,26,0.13)] ${messageIndex === 0 ? 'rounded-tl-none' : ''} ${message.photo ? 'p-1' : 'px-1 py-0.5'}`} data-id="element-239" data-mp="32g49b6ok2in7" data-mpi={messageIndex}>
                          {messageIndex === 0 && <BubbleTail data-id="element-240" data-mp="3ggowsg5f12n1" />}
                          {message.photo && <img src={message.photo} alt={`Foto que mandó ${item.name}`} className="mb-1 w-full rounded-md" loading="lazy" data-id="element-241" data-mp="3gg5dow41487f" />}
                          <p className="px-1.5 pb-1 pt-0.5 text-[14.2px] leading-[1.45] text-[#111b21]" data-id="element-242" data-mp="2opirllau8eqw">
                            {message.text}
                          </p>
                        </div>)}
                    </div>

                    <div className="mt-4 flex items-center gap-1.5" aria-hidden="true" data-id="element-243" data-mp="2xiune10dkp44">
                      <div className="flex min-w-0 flex-1 items-center gap-2.5 rounded-full bg-white px-3 py-2.5 text-[#8696a0] shadow-[0_1px_0.5px_rgba(11,20,26,0.13)]" data-id="element-244" data-mp="210q1w6kt734q">
                        <SmileIcon className="h-5 w-5 shrink-0" data-id="element-245" data-mp="1lwwr056b18n9" />
                        <span className="min-w-0 flex-1 truncate text-[15px]" data-id="element-246" data-mp="1lx6hdtv9hhth">Mensaje</span>
                        <PaperclipIcon className="h-5 w-5 shrink-0 -rotate-45" data-id="element-247" data-mp="1gzdcd45p2tus" />
                        <CameraIcon className="h-5 w-5 shrink-0" data-id="element-248" data-mp="1vnrl1vpslcj9" />
                      </div>
                      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#00a884] text-white" data-id="element-249" data-mp="1quyj1flpkiav">
                        <MicIcon className="h-5 w-5" data-id="element-250" data-mp="24ljtqh10dlxo" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-1 px-4 py-3" aria-label="5 de 5 estrellas" data-id="element-251" data-mp="2em3xbqc032j2">
                  {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-5 w-5 fill-[#f5a623] text-[#f5a623]" aria-hidden="true" data-id="element-252" data-mp="29nsnvgpmau1d" />)}
                </div>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}